const loginModule = {
  login: "Member login",
  phonePlaceholder: "Please enter cellphone number",
  emailPlaceholder: "Please enter email",
  passwordPlaceholder: "Please enter password",
  register: "Register member",
  forgetText: "Forget password",
  ruleText1: "Terms for usage",
  ruleText2: "Personal Information collection",
  ruleText3: "Agree",
  rule: "Terms for usage",
  questionText: "When encountering problems upon login",
  questionSubText: "Partial available functions are limited",
  otherLogin: "Other login",
  otherLoginText: "Log in other ways",
  routeLoading: "Re-directing...",
  returnLogin: "Exit",
  visitorsLogin: "Visitors to login",
  agentWarn: "[Anonymous Login] Using traceless mode or clearing the browser cache will result in loss of user information.",
  emailPlaceholder: "Please enter email",
  accountExample: "ID(例：08012341234)",
  lineLogin: "LINE login",
  lineLoginDesc: "To use it on LINE, click 'Sign in on LINE' and then 'Allow'.",
  nohaveAccount: "Don't have an account number?"
};

export default loginModule;
